module.exports = __webpack_public_path__ + "static/BLOG-POST-INTERIOR-BG.da8088a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Blog/BLOG-POST-INTERIOR-BG.jpg
// module id = 492
// module chunks = 107818501498521